import { create } from 'zustand';

/**
 * Store global do ticket atualmente aberto na thread.
 * Usado pelo hook de notificações pra evitar notificar mensagens do ticket
 * que o atendente já está visualizando.
 */
interface OpenTicketStore {
  openTicketId: number | null;
  setOpenTicketId: (id: number | null) => void;
}

export const useOpenTicketStore = create<OpenTicketStore>((set) => ({
  openTicketId: null,
  setOpenTicketId: (id) => set({ openTicketId: id }),
}));
